/**
 * kult-b2b-reset.js — Privatkundenbereich: entfernt das Warenkorb-Attribut „Firmenbestellung“, wenn es hängen
 * geblieben ist (Besuch des Firmenkunden-Bereichs) und im Warenkorb keine Firmenpositionen (_kultb2b…) liegen.
 * Läuft einmal je Seitenaufruf und nach Warenkorb-Änderungen. Liegen Firmenpositionen im Warenkorb, bleibt es.
 * Firmenzeile = Eigenschaft _kultb2b… (_kultb2b: Präsente, _kultb2b_quelle: Bürokaffee/Firmenkunden-Shop); gleiches Kriterium
 * wie hasB2bLine in assets/kult-cart.js (dort zusätzlich Bereinigung nach Entfernen/Leeren und im Firmenkunden-Bereich).
 */
(function () {
  'use strict';
  if (window.__kultB2bReset) return;
  window.__kultB2bReset = true;
  var busy = false;
  function hasB2bItem(cart) {
    return (cart.items || []).some(function (it) {
      var p = it.properties || {};
      return Object.keys(p).some(function (k) { return k.indexOf('_kultb2b') === 0; });
    });
  }
  function check(cart) {
    if (busy || !cart || !cart.attributes || !cart.attributes.Firmenbestellung || hasB2bItem(cart)) return;
    busy = true;
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: { Firmenbestellung: '' } })
    }).then(function (r) { return r.json(); }).then(function () {
      try { window.localStorage.removeItem('kult:b2b'); } catch (e) { /* kein Speicher */ }
    }).catch(function () { /* nächster Seitenaufruf */ }).then(function () { busy = false; });
  }
  function run() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); }).then(check).catch(function () {});
  }
  run();
  document.addEventListener('kult:cart:updated', function (e) { check(e.detail && e.detail.cart); });
})();
